"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CardComponent.default;
  }
});

var _CardComponent = _interopRequireDefault(require("./Card-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }